import api from '../utils/api';

const frontOfficeService = {
  listVisitors: async (status) => {
    try {
      return await api.get('/api/front-office/visitors', { params: { status } });
    } catch (error) {
      console.error('Error fetching visitors:', error);
      throw error;
    }
  },

  checkInVisitor: async (data) => {
    try {
      return await api.post('/api/front-office/visitors', data);
    } catch (error) {
      console.error('Error checking in visitor:', error);
      throw error;
    }
  },

  getVisitorByBadge: async (badgeNumber) => {
    try {
      return await api.get(`/api/front-office/visitors/by-badge/${badgeNumber}`);
    } catch (error) {
      console.error('Error looking up visitor by badge:', error);
      throw error;
    }
  },

  getVisitor: async (visitorId) => {
    try {
      return await api.get(`/api/front-office/visitors/${visitorId}`);
    } catch (error) {
      console.error('Error fetching visitor:', error);
      throw error;
    }
  },

  updateVisitor: async (visitorId, data) => {
    try {
      return await api.put(`/api/front-office/visitors/${visitorId}`, data);
    } catch (error) {
      console.error('Error updating visitor:', error);
      throw error;
    }
  },

  checkOutVisitor: async (visitorId) => {
    try {
      return await api.post(`/api/front-office/visitors/${visitorId}/check-out`);
    } catch (error) {
      console.error('Error checking out visitor:', error);
      throw error;
    }
  },

  deleteVisitor: async (visitorId) => {
    try {
      return await api.delete(`/api/front-office/visitors/${visitorId}`);
    } catch (error) {
      console.error('Error deleting visitor:', error);
      throw error;
    }
  },

  approveVisitor: async (visitorId) => {
    try {
      return await api.post(`/api/front-office/visitors/${visitorId}/approve`);
    } catch (error) {
      console.error('Error approving visitor:', error);
      throw error;
    }
  },

  rejectVisitor: async (visitorId, rejectionReason) => {
    try {
      return await api.post(`/api/front-office/visitors/${visitorId}/reject`, { rejection_reason: rejectionReason });
    } catch (error) {
      console.error('Error rejecting visitor:', error);
      throw error;
    }
  },

  // --- Gate Passes ---
  getGatePasses: async (params) => {
    try {
      return await api.get('/api/front-office/gate-passes', { params });
    } catch (error) {
      console.error('Error fetching gate passes:', error);
      throw error;
    }
  },

  createGatePass: async (data) => {
    try {
      return await api.post('/api/front-office/gate-passes', data);
    } catch (error) {
      console.error('Error creating gate pass:', error);
      throw error;
    }
  },

  approveGatePass: async (id) => {
    try {
      return await api.post(`/api/front-office/gate-passes/${id}/approve`);
    } catch (error) {
      console.error('Error approving gate pass:', error);
      throw error;
    }
  },

  rejectGatePass: async (id) => {
    try {
      return await api.post(`/api/front-office/gate-passes/${id}/reject`);
    } catch (error) {
      console.error('Error rejecting gate pass:', error);
      throw error;
    }
  },

  exitGatePass: async (id) => {
    try {
      return await api.post(`/api/front-office/gate-passes/${id}/exit`);
    } catch (error) {
      console.error('Error recording gate pass exit:', error);
      throw error;
    }
  },

  returnGatePass: async (id) => {
    try {
      return await api.post(`/api/front-office/gate-passes/${id}/return`);
    } catch (error) {
      console.error('Error recording gate pass return:', error);
      throw error;
    }
  },

  getGatePassByNumber: async (passNumber) => {
    try {
      return await api.get(`/api/front-office/gate-passes/by-number/${passNumber}`);
    } catch (error) {
      console.error('Error looking up gate pass by number:', error);
      throw error;
    }
  },

  // --- Appointments ---
  getAppointments: async (params) => {
    try {
      return await api.get('/api/front-office/appointments', { params });
    } catch (error) {
      console.error('Error fetching appointments:', error);
      throw error;
    }
  },

  createAppointment: async (data) => {
    try {
      return await api.post('/api/front-office/appointments', data);
    } catch (error) {
      console.error('Error creating appointment:', error);
      throw error;
    }
  },

  updateAppointment: async (id, data) => {
    try {
      return await api.put(`/api/front-office/appointments/${id}`, data);
    } catch (error) {
      console.error('Error updating appointment:', error);
      throw error;
    }
  },

  checkInAppointment: async (id) => {
    try {
      return await api.post(`/api/front-office/appointments/${id}/check-in`);
    } catch (error) {
      console.error('Error checking in appointment:', error);
      throw error;
    }
  },

  // --- Courier / Mail ---
  getCourierItems: async (params) => {
    try {
      return await api.get('/api/front-office/courier-items', { params });
    } catch (error) {
      console.error('Error fetching courier items:', error);
      throw error;
    }
  },

  createCourierItem: async (data) => {
    try {
      return await api.post('/api/front-office/courier-items', data);
    } catch (error) {
      console.error('Error creating courier item:', error);
      throw error;
    }
  },

  updateCourierItem: async (id, data) => {
    try {
      return await api.put(`/api/front-office/courier-items/${id}`, data);
    } catch (error) {
      console.error('Error updating courier item:', error);
      throw error;
    }
  },
};

export default frontOfficeService;
